import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing16, spacing24, grey2, info40, info60, text120 } from "../../../../eden-style-constants";
import { Title4 } from "../../../../eden-headings";
import { Summary as EdenSummary } from "../../../../eden-details";
const HandleOuter = styled(EdenSummary).withConfig({
  componentId: "sc-1rgj0tw-0"
})(["padding-inline-start:", ";padding-inline-end:", ";color:", ";&:hover{text-decoration:underline 1px solid ", ";background:", ";}details[open] > &&{text-decoration:none;color:", ";background:none;}"], spacing24, spacing16, info40, info60, grey2, text120);
const Title = styled(Title4).withConfig({
  componentId: "sc-1rgj0tw-1"
})(["display:inline-block;margin:0;padding:", " 0;text-align:start;width:100%;padding-inline-end:", ";"], spacing24, spacing16);

const Summary = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(HandleOuter, props, /*#__PURE__*/React.createElement(Title, null, children));
};

Summary.propTypes = {
  /** Contents rendered inside the Summary */
  children: PropTypes.node.isRequired
};
export default Summary;